<template>
  <div class="cr05341-view">
    <el-row type="flex" class="overall-status" justify="end">
      <el-col tag="span" :span="3">
        {{ $t('报警状态') }}：
        <span :class="state | alarmClass">{{ state | alarmText }}</span>
      </el-col>
    </el-row>
    <div class="chart-area">
      <v-chart
        v-for="(item, index) in chartData"
        :key="index"
        class="chart"
        :options="item"
        :autoresize="true"
      />
    </div>
  </div>
</template>

<script>
import { formatTimestamp } from '@/utils/utils';
import { tools } from '../CT1226/utils';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/echartOption/common';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';

export default {
  name: 'CR05341',
  mixins: [singleDeviceMixin],
  filters: tools,
  sockets: {
    '/socket/detail'(res) {
      this.update(res);
    }
  },
  data() {
    return {
      maxLen: 30,
      state: 0,
      alarmType: null,
      chartData: [
        lineAreaStyle({
          color: ['#833BBB', '#3368F2'],
          legend: {
            top: 'auto',
            right: '5%',
            icon: 'circle',
            orient: 'vertical',
            textStyle: {
              color: '#fff'
            }
          },
          title: { text: 'α', left: 'center' },
          yAxis: { type: 'value' },
          xAxis: {
            type: 'category',
            data: []
          },
          series: [
            {
              name: 'α',
              type: 'line',
              symbol: 'emptyCircle',
              areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') },
              smooth: true,
              data: []
            }
          ]
        }),

        lineAreaStyle({
          color: ['#833BBB', '#3368F2'],
          legend: {
            top: 'auto',
            right: '5%',
            icon: 'circle',
            orient: 'vertical',
            textStyle: {
              color: '#fff'
            }
          },
          title: { text: 'β', left: 'center' },
          yAxis: { type: 'value' },
          xAxis: {
            type: 'category',
            data: []
          },
          series: [
            {
              name: 'β',
              type: 'line',
              symbol: 'emptyCircle',
              areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') },
              smooth: true,
              data: []
            }
          ]
        })
      ]
    };
  },
  mounted() {
    this.normalColor = graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)');
    this.warinColor = graColor('rgb(250, 96, 100)', 'rgba(250, 96, 100,0.1)');
  },
  methods: {
    update(res) {
      //   console.log('res: ', res);
      if (res.sn === this.sn) {
        this.setData(res);
      }
    },
    setData(res) {
      this.state = res.state;
      let { nuclearMod } = res.mods;

      let { rg04Dto } = nuclearMod;
      //   console.log('type', rg04Dto.alarmType);

      switch (rg04Dto.alarmType) {
        case 1:
          // alpha报警
          this.chartData[0].series[0].areaStyle.color = this.warinColor;
          this.chartData[1].series[0].areaStyle.color = this.normalColor;
          break;

        case 2:
          // beta报警
          this.chartData[0].series[0].areaStyle.color = this.normalColor;
          this.chartData[1].series[0].areaStyle.color = this.warinColor;

          break;
        case 3:
          // alpha报警、beta报警
          this.chartData[0].series[0].areaStyle.color = this.warinColor;
          this.chartData[1].series[0].areaStyle.color = this.warinColor;
          break;
        default:
          this.chartData.forEach(item => {
            item.series[0].areaStyle.color = this.normalColor;
          });
          break;
      }

      this.chartData[0].xAxis.data.push(formatTimestamp(res.beginTime));
      this.chartData[0].series[0].data.push(rg04Dto.alphaProbeValue);

      this.chartData[1].xAxis.data.push(formatTimestamp(res.beginTime));
      this.chartData[1].series[0].data.push(rg04Dto.betaProbeValue);

      if (this.chartData[0].xAxis.data.length > this.maxLen) {
        this.chartData.forEach(item => {
          item.xAxis.data.shift();
          item.series[0].data.shift();
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.cr05341-view {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;

  .overall-status {
    font-weight: bold;
    font-size: 20px;
    span {
      @include state-textstyle;
    }
  }

  .chart-area {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: calc(100% - 100px);
    .chart {
      border: 1px solid rgb(96, 118, 173) !important;
      height: 90% !important;
      width: 45% !important;
    }
  }
}
</style>
